<template>
	<div class="card">
		<div class="card-header">
			<span class="fs-6">Data Utama</span>
		</div>
		<div class="card-body" v-loading="loading">
			<el-table :data="jenisData" ref="tableDataUtama" @row-click="expandRow" row-key="table_name">
				<el-table-column type="expand">
					<template #default="props">
						<div class="mx-4 my-2">
							<div class="d-flex flex-wrap align-items-center gap-2 m-2">
								<span class="fs-5">Struktur Tabel {{ props.row.description }}</span>
								<transition name="fade" mode="out-in">
									<el-button
										:key="edits[props.row.table_name]"
										:type="edits[props.row.table_name] ? 'info' : 'primary'"
										:icon="edits[props.row.table_name] ? 'Close' : 'Edit'"
										size="small"
										plain
										round
										@click="edits[props.row.table_name] = !edits[props.row.table_name]"
										class="ms-auto">
										{{ edits[props.row.table_name] ? "Batal Edit" : "Edit" }}
									</el-button>
								</transition>
							</div>
							<el-form
								:model="forms[props.row.table_name]"
								@submit.prevent="updateMandatory(props.row)"
								:disabled="!edits[props.row.table_name] || loadingForms[props.row.table_name]"
								:ref="`form_${props.row.table_name}_ref`">
								<el-table :data="props.row.fields" table-layout="auto" size="small">
									<el-table-column type="index" label="No." />
									<el-table-column label="Data" prop="col">
										<template #default="{ row }">
											{{ descriptions[row.col] || row.col }}
										</template>
									</el-table-column>
									<el-table-column label="Status" prop="is_required">
										<template #default="{ row }">
											<el-form-item class="m-0">
												<el-switch v-model="forms[props.row.table_name][row.col]" size="small" active-text="Harus" inactive-text="Opsional" />
											</el-form-item>
										</template>
									</el-table-column>
								</el-table>

								<div class="mt-2 text-end" v-if="edits[props.row.table_name]">
									<el-button type="info" plain @click="edits[props.row.table_name] = false">Batal</el-button>
									<el-popover title="Perhatian" width="40%">
										<template #default>
											<p class="small" style="text-align: justify">
												Setelah melakukan pembaruan jenis bagian yang harus diisi maupun opsional, diperlukan penghitungan ulang persentase kelengkapan semua siswa. Jika
												penghitungan ulang tidak dilakukan, maka persentase kelengkapan hanya akan diperbarui ketika ada tindakan pembaruan data rinci siswa.
											</p>
										</template>
										<template #reference>
											<el-button type="success" native-type="submit" :loading="loadingForms[props.row.table_name]">Simpan*</el-button>
										</template>
									</el-popover>
								</div>
							</el-form>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="Tabel" prop="description" header-align="center" />
				<el-table-column label="Jumlah Bagian" align="center">
					<el-table-column label="Total" prop="fields.length" label-class-name="small" align="center" />
					<el-table-column label="Harus diisi" prop="required_fields_count" label-class-name="small" align="center" />
				</el-table-column>
			</el-table>
			<el-divider />
			<el-form inline label-width="auto" :disabled="loadingRefresh" @submit.prevent="refreshPersentaseKelengkapan">
				<el-form-item label="Perbarui persentase kelengkapan siswa">
					<el-input-number v-model="siswaRows" :min="50" :max="1000" :step="50">
						<template #suffix>siswa</template>
					</el-input-number>
				</el-form-item>
				<el-form-item>
					<el-button type="info" icon="Refresh" native-type="submit" :loading="loadingRefresh">Perbarui</el-button>
				</el-form-item>
			</el-form>
			<el-form inline label-width="auto" :disabled="loadingDownload" @submit.prevent="downloadDataRinciSiswa">
				<el-form-item label="Unduh data rinci siswa">
					<el-select v-model="semester" value-key="semester_id" placement="bottom-end" placeholder="Semester" style="width: 200px">
						<el-option v-for="s in listSemester" :key="s" :label="s.nama" :value="s" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="success" icon="Download" native-type="submit" :loading="loadingDownload">Unduh</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
export default {
	name: "UtamaView",
	data() {
		return {
			listSemester: [],
			semester: null,
			jenisData: [],
			loading: true,
			descriptions: {
				alamat: "Alamat",
				alamat_sama: "Alamat sama dengan siswa",
				anak_ke: "Anak ke-",
				berat_badan: "Berat Badan",
				berkebutuhan_khusus_id: "Jenis Kebutuhan Khusus",
				catatan: "Catatan",
				cita_cita_id: "Cita-cita",
				desa: "Desa",
				foto_akta: "Foto Akta Kelahiran",
				foto_diri: "Foto Diri Siswa",
				foto_ijazah_smp: "Foto Ijazah SMP/MTs",
				foto_kk: "Foto Kartu Keluarga",
				foto_ktp: "Foto KTP",
				google_maps: "Tautan Maps",
				hobi_id: "Hobi",
				jarak_tempat_tinggal: "Jarak Tempat Tinggal",
				jenis_wali: "Jenis Wali",
				jumlah_saudara: "Jumlah Saudara",
				kabupaten_kota: "Kabupatan/Kota",
				kecamatan: "Kecamatan",
				kontak: "Kontak",
				lingkar_kepala: "Lingkar Kepala",
				moda_transportasi_id: "Jenis Moda Transportasi",
				nama: "Nama",
				nik: "Nomor Induk Kependudukan",
				nisn: "Nomor Induk Siswa Nasional",
				no_kk: "Nomor Kartu Keluarga",
				no_reg_akta_lahir: "Nomor Registrasi Akta Kelahiran",
				no_seri_ijazah_smp: "Nomor Seri Ijazah SMP/MTs",
				npsn_asal_smp: "Asal SMP/Mts",
				pekerjaan_id: "Jenis Pekerjaan",
				pendidikan_dasar_id: "Pendidikan Dasar",
				pendidikan_id: "Jenjang Pendidikan Terakhir",
				penghasilan_id: "Rentang Penghasilan",
				penulisan_ttl: "Penulisan Tempat dan Tanggal Lahir",
				pernah_paud_formal: "Pernah PAUD Formal",
				pernah_paud_nonformal: "Penah PAUD Nonformal",
				provinsi: "Provinsi",
				relasi: "Hubungan",
				rt: "RT",
				rw: "RW",
				status_ortu_id: "Status Orang Tua",
				tahun_lahir: "Tahun Lahir",
				tahun_wafat: "Tahun Wafat",
				tanggal_lahir: "Tanggal Lahir",
				tempat_lahir: "Tempat Lahir",
				tempat_tinggal_id: "Jenis Tempat Tinggal",
				tinggi_badan: "Tinggi Badan",
				waktu_tempuh: "Waktu Tempuh",
			},
			edits: {
				detail_siswa: false,
				data_ayah: false,
				data_ibu: false,
				data_wali: false,
			},
			loadingForms: {
				detail_siswa: false,
				data_ayah: false,
				data_ibu: false,
				data_wali: false,
			},
			originalForms: {
				detail_siswa: null,
				data_ayah: null,
				data_ibu: null,
				data_wali: null,
			},
			forms: {
				detail_siswa: {},
				data_ayah: {},
				data_ibu: {},
				data_wali: {},
			},
			siswaRows: 100,
			loadingRefresh: false,
			loadingDownload: false,
			updatedMandatory: (data) => {
				const d = JSON.parse(data);
				const { table_name = null, adds = [], dels = [] } = d;

				const table = this.jenisData.find((j) => j.table_name === table_name);

				if (!table) return;

				table.required_fields_count = table.required_fields_count - dels.length + adds.length;
				adds.forEach((c) => {
					const field = table.fields?.find((f) => f.col === c);
					if (field) {
						field.is_required = true;
						this.forms[table_name][c] = true;
					}
				});
				dels.forEach((c) => {
					const field = table.fields?.find((f) => f.col === c);
					if (field) {
						field.is_required = false;
						this.forms[table_name][c] = false;
					}
				});

				const tmp = {};
				const fields = table.fields || [];
				fields.forEach((f) => {
					tmp[f.col] = f.is_required;
				});
				this.originalForms[table_name] = JSON.stringify(tmp);
			},
		};
	},
	computed: {
		semesterAktif() {
			return this.$store.getters.getSemester;
		},
	},
	watch: {
		"edits.detail_siswa"(val) {
			if (!val) {
				this.forms.detail_siswa = JSON.parse(this.originalForms.detail_siswa);
			}
		},
		"edits.data_ayah"(val) {
			if (!val) {
				this.forms.data_ayah = JSON.parse(this.originalForms.data_ayah);
			}
		},
		"edits.data_ibu"(val) {
			if (!val) {
				this.forms.data_ibu = JSON.parse(this.originalForms.data_ibu);
			}
		},
		"edits.data_wali"(val) {
			if (!val) {
				this.forms.data_wali = JSON.parse(this.originalForms.data_wali);
			}
		},
	},
	mounted() {
		this.getListSemester();
		this.semester = this.semesterAktif;
		this.getJenisData();
		this.$ws.main.on("jenis-data:updated", this.updatedMandatory);
	},
	beforeUnmount() {
		this.$ws.main.off("jenis-data:updated");
	},
	methods: {
		async getListSemester() {
			try {
				const { data } = await this.$defaultApi.post("/list/semester");

				this.listSemester = data.semester;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			}
		},
		expandRow(row) {
			this.$refs.tableDataUtama.toggleRowExpansion(row);
		},
		async getJenisData() {
			this.loading = true;
			try {
				const { data } = await this.$defaultApi.post("/data/jenis-data");

				const result = data.jenis_data;
				Object.keys(this.forms).forEach((t) => {
					const tmp = {};
					const table = result.find((r) => r.table_name === t);
					if (table) {
						const fields = table.fields || [];

						fields.forEach((f) => {
							tmp[f.col] = f.is_required;
						});

						this.originalForms[t] = JSON.stringify(tmp);
						this.forms[t] = tmp;
					}
				});
				this.jenisData = result;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			}
		},
		async updateMandatory(row) {
			this.loadingForms[row.table_name] = true;

			try {
				if (this.originalForms[row.table_name] === JSON.stringify(this.forms[row.table_name])) {
					throw Error("Belum ada perubahan");
				}

				const dels = [];
				const adds = [];

				const originalForm = JSON.parse(this.originalForms[row.table_name]);
				Object.entries(this.forms[row.table_name]).forEach(([key, val]) => {
					if (originalForm[key] === true && val === false) dels.push(key);
					if (originalForm[key] === false && val === true) adds.push(key);
				});

				const { data } = await this.$defaultApi.post("/data/jenis-data/update-mandatory", {
					table_name: row.table_name,
					fields_to_del: dels,
					fields_to_add: adds,
				});

				await new Promise((resolve) => {
					setTimeout(() => {
						this.edits[row.table_name] = false;

						resolve();
					}, 500);
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.loadingForms[row.table_name] = false;
				}, 500);
			}
		},
		async refreshPersentaseKelengkapan() {
			this.loadingRefresh = true;
			try {
				const { data } = await this.$defaultApi.post("/progres/refresh-all", {
					limit: this.siswaRows,
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.loadingRefresh = false;
				}, 500);
			}
		},
		async downloadDataRinciSiswa() {
			this.loadingDownload = true;
			try {
				const { data, headers } = await this.$defaultApi.post(
					"/data/download",
					{
						semester_id: this.semester.semester_id,
					},
					{
						responseType: "blob",
					}
				);

				const contentDisposition = headers["content-disposition"];
				let fileName = "DataRinciSiswa.xlsx";

				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?([^"]+)"?/);
					if (match && match[1]) {
						fileName = decodeURIComponent(match[1]);
					}
				}

				const url = window.URL.createObjectURL(new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

				const a = document.createElement("a");
				a.href = url;
				a.download = fileName;
				document.body.appendChild(a);

				await new Promise((resolve) => {
					setTimeout(() => {
						a.click();
						a.remove();
						window.URL.revokeObjectURL(url);

						resolve();
					}, 500);
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.loadingDownload = false;
				}, 500);
			}
		},
	},
};
</script>

<style scoped></style>
